export default function translate(i18n, propriete) {
  if (propriete === '[0].ReferencePaiement') {
    return i18n.t('listeEcheancesAPayer.popUpEditEcheancesAPayer.messages.errors.refPaiement');
  }
  if (propriete === '[0].Commentaire') {
    return i18n.t('listeEcheancesAPayer.popUpEditEcheancesAPayer.messages.errors.commentaire');
  }
  if (propriete === 'datePlanification') {
    return i18n.t('listeEcheancesAPayer.popUpReplanification.messages.errors.posePlanification');
  }
  if (propriete.indexOf('infosPaiement') === 0 && propriete.indexOf('DomiciliationBancaireId') !== -1) {
    return i18n.t('listeEcheancesAPayer.popUpCreationLotPaiement.errors.banque');
  }
  if (propriete.indexOf('infosPaiement') === 0 && propriete.indexOf('ModeReglementId') !== -1) {
    return i18n.t('listeEcheancesAPayer.popUpCreationLotPaiement.errors.modePaiement');
  }
  if (propriete === 'dateReglement') {
    return i18n.t('listeEcheancesAPayer.popUpCreationLotPaiement.errors.datePaiement');
  }
  return propriete;
}
